module.exports = __webpack_public_path__ + "static/media/FooterLogo.c0e6853c.png";